import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 10a2 2 0 1 1-4.001-.001A2 2 0 0 1 6 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 12 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 18 10z",
  fillRule: "evenodd"
});

var SvgHorizontalDotsMinor = function SvgHorizontalDotsMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgHorizontalDotsMinor as S };
